import { call, put, takeEvery } from "redux-saga/effects";

import {
  GET_CHARTS_DATA,
  GET_TASK_DATA,
  APPROVE_TASK,
  TEAM_DASHBOARD_LIST,
  TEAM_ACTION,
  TEAM_SHIFT_START_ACTION,
  TEAM_SHIFT_END_ACTION,
  TEAM_TASK_LIST,
} from "./actionTypes";
import {
  apiSuccess,
  apiFail,
  getTaskDataSuccess,
  getTaskDataFail,
  approveTaskFail,
  approveTaskSuccess,
  teamDashboardListFail,
  teamDashboardListSuccess,
  teamActionSuccess,
  teamActionFail,
  teamShiftStartActionSuccess,
  teamShiftStartActionFail,
  teamShiftEndActionSuccess,
  teamShiftEndActionFail,
  teamTaskListSuccess,
  teamTaskListFail,
} from "./actions";

import {
  getWeeklyData,
  getYearlyData,
  getMonthlyData,
  getTaskList,
  approveTaskToStaff,
  onGettingTeamDashboardList,
  onAppyTeamAction,
  onTeamAppyShiftStartAction,
  onTeamAppyShiftEndAction,
  onGettingTeamTask,
} from "helpers/fakebackend_helper";

import showToast from "common/Notification";
import { responseHandler } from "common/CommanFunction";

const toastTitle = "Dashboard";

function* fetchTaskList({ payload: data }) {
  try {
    const response = yield call(getTaskList, data);
    yield put(getTaskDataSuccess(response));
  } catch (error) {
    yield put(getTaskDataFail(error));
  }
}

function* getChartsData({ payload: periodType }) {
  try {
    var response;
    if (periodType == "monthly") {
      response = yield call(getWeeklyData, periodType);
    }
    if (periodType == "yearly") {
      response = yield call(getYearlyData, periodType);
    }
    if (periodType == "weekly") {
      response = yield call(getMonthlyData, periodType);
    }

    yield put(apiSuccess(GET_CHARTS_DATA, response));
  } catch (error) {
    yield put(apiFail(GET_CHARTS_DATA, error));
  }
}

function* Approve_Task_To_Staff({ payload: data }) {
  try {
    const response = yield call(approveTaskToStaff, data);
    if (response.status) {
      yield put(approveTaskSuccess(response));
      showToast("success", "Approving Task", response.message);
    } else {
      yield put(approveTaskFail(response));
      showToast("error", "Approving Task", response.message);
    }
  } catch (error) {
    yield put(approveTaskFail(error));
    showToast("error", "Approving Task", error);
  }
}

function* onGetTeamDashboardList({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingTeamDashboardList, data);
    yield call(responseHandler, toastTitle, response, teamDashboardListSuccess, teamDashboardListFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(teamDashboardListFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onTeamAction({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onAppyTeamAction, data);
    yield call(responseHandler, "My Shift", response, teamActionSuccess, teamActionFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(teamActionFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onTeamShiftStartAction({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onTeamAppyShiftStartAction, data);
    yield call(responseHandler, toastTitle, response, teamShiftStartActionSuccess, teamShiftStartActionFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(teamShiftStartActionFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onTeamShiftEndAction({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onTeamAppyShiftEndAction, data);
    yield call(responseHandler, toastTitle, response, teamShiftEndActionSuccess, teamShiftEndActionFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(teamShiftEndActionFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onGetTeamTask({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingTeamTask, data);
    yield call(responseHandler, toastTitle, response, teamTaskListSuccess, teamTaskListFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(teamTaskListFail(error));
    showToast("error", toastTitle, error);
  }
}

export function* watchGetChartsData() {
  yield takeEvery(GET_CHARTS_DATA, getChartsData);
  yield takeEvery(GET_TASK_DATA, fetchTaskList);
  yield takeEvery(APPROVE_TASK, Approve_Task_To_Staff);
  yield takeEvery(TEAM_ACTION, onTeamAction);
  yield takeEvery(TEAM_TASK_LIST, onGetTeamTask);
  yield takeEvery(TEAM_SHIFT_START_ACTION, onTeamShiftStartAction);
  yield takeEvery(TEAM_SHIFT_END_ACTION, onTeamShiftEndAction);
  yield takeEvery(TEAM_DASHBOARD_LIST, onGetTeamDashboardList);
}

export default watchGetChartsData;
